import React from 'react';
import Layout from '../components/layout/Layout';
import StrengthReportForm from '../components/reports/StrengthReportForm';

const StrengthReportPage = () => {
  return (
    <Layout>
      <StrengthReportForm />
    </Layout>
  );
};

export default StrengthReportPage;
